module.exports = __webpack_public_path__ + "static/media/inr_santa.54c1186a.usdz";